import { type FC, type ReactElement, type ReactNode } from 'react';

import { useTranslation } from 'react-i18next';

import { Icon } from '@wf/components';

import styles from './EmptyTable.module.scss';

export interface IProps {
  children?: ReactElement;
  title?: string;
  text?: string;
  iconName?: string;
  iconSize?: number | string;
  button?: ReactNode;
}

const EmptyTableContent: FC<IProps> = ({ children, title, text, button, iconName, iconSize = 34 }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      {children ? (
        children
      ) : (
        <>
          <Icon className={styles.icon} name={iconName ? iconName : 'il_document'} size={iconSize} />
          <h3 className={styles.title}>{title || t('There is no result')}</h3>
          {text && <span className={styles.text}>{text}</span>}
          {button}
        </>
      )}
    </div>
  );
};

export default EmptyTableContent;
